import React from 'react';
import { IconProps } from './model/IconInterface';

const ChecklistIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor', fill }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? color : 'none'}
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M3 5.5L4.5 7 7 4.5" /><path d="M3 12.5L4.5 14 7 11.5" /><path d="M3 19.5L4.5 21 7 18.5" /><line x1="10" y1="6" x2="21" y2="6" /><line x1="10" y1="13" x2="21" y2="13" /><line x1="10" y1="20" x2="21" y2="20" />
    </svg>
  );
};

export default ChecklistIcon;
